import { ButtonProperties } from "./ButtonProperties";
/**
 * ToggleButtonProperties.ts
 */
export class ToggleButtonProperties extends ButtonProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.isToggle = true;
        this.movieClipProperties.numberOfFrames = 8;
    }
}
//# sourceMappingURL=ToggleButtonProperties.js.map